import API from 'services/API';

export const getArmyPrivileges = () => {
  return API.request({
    url: '/profile/supportMeasuresForMobilized',
    method: 'GET',
  });
};
